<template lang="pug">
el-form(ref='judgmentForm', :model='printerJudgment', label-width='190px', v-loading="this.saving")
  el-form-item.compact-form-item(:label='gradeLabel()' v-if="!this.isReappraisal" :style="{ lineHeight: '10px !important' }")
    | {{ application.grade }}
  el-form-item.compact-form-item(v-if='application.grade_description' :label='gradeDescriptionLabel()')
    | {{ application.grade_description }}
  el-form-item.compact-form-item(v-if='application.certificationTitleByInternal' label='Τίτλος Σπουδών')
    | {{ application.certificationTitleByInternal }}
  el-form-item(label='Απόφαση Προέδρου')
    span(v-loading='loadingPresidentDecision') {{presidentDecisionText}}
  el-form-item(label='Με', v-if='departmentName')
    span {{departmentName}}
  el-form-item(label='Εσωτερικό Σχόλιο')
    el-input.biggest(type='textarea', :autosize='{ minRows: 4, maxRows: 10}',
      placeholder='Εισάγετε κείμενο για τον Πρόεδρο', v-model='printerJudgment.comment')
  el-form-item(label='Στην Αναμονή')
    el-checkbox(v-model='printerJudgment.queue', @change='toggleQueue',
      label='Ναι', border='')
  el-form-item(label='Χρώμα')
    el-input(placeholder='Εισάγεται χρώμα', v-model='printerJudgment.color')
  hr
  proposals
  internalComments
  div
    el-form-item(label='Επικαιροποίηση')
      el-radio-group(v-model='actApproval.approved' disabled)
        el-radio(:label='true') Ορθά στοιχεία
        el-radio(:label='false') Διόρθωση στοιχείων
    el-form-item(label='Παρατηρήσεις')
      el-input.biggest(type='textarea', :autosize='{ minRows: 4, maxRows: 10}',
        placeholder='Παρατηρήσεις για πράξη', v-model='actApproval.comment' disabled)
    el-form-item(label='Ημερομηνία Προσχεδίου')
      span(:style="calcStyleDraft()") {{timeDraftUpload}}
    el-form-item(label='Ημερομηνία Έγκρισης')
      span(:style="calcStyleApproval()") {{timeApprovedByUser}}
    el-form-item(label='Έκδοση πράξης/επιστολής' v-if="this.isReappraisal")
      el-select(v-model='issuance' placeholder='Παρακαλώ Επιλέξτε' v-if="this.attachments.length===0")
        el-option(label='Έκδοση νέας πράξης αναγνώρισης' value='issueAct' :disabled="['ΑΠΟΡΡΙΨΗ ΩΣ ΕΚΠΡΟΘΕΣΜΗΣ', 'ΕΜΜΟΝΗ ΣΤΗΝ ΠΡΟΗΓΟΥΜΕΝΗ ΠΡΑΞΗ ΑΝΑΓΝΩΡΙΣΗΣ'].includes(this.presidentDecisionText)")
        el-option(label='Έκδοση επιστολής απόρριψης εκπρόθεσμης αίτησης' value='issueOverdue' :disabled="this.presidentDecisionText !== 'ΑΠΟΡΡΙΨΗ ΩΣ ΕΚΠΡΟΘΕΣΜΗΣ'")
        el-option(label='Έκδοση επιστολής εμμονής στην προηγ. πράξη' value='issueLetter' :disabled="this.presidentDecisionText !== 'ΕΜΜΟΝΗ ΣΤΗΝ ΠΡΟΗΓΟΥΜΕΝΗ ΠΡΑΞΗ ΑΝΑΓΝΩΡΙΣΗΣ'")
      el-alert(v-if="this.attachments.length!= 0" type='info' show-icon='' closable=false title='Υπάρχει ανεβασμένη πράξη/ επιστολή.')
    el-form-item(v-if="issuance === 'issueLetter' || issuance === 'issueOverdue' || (this.attachments.length !== 0 && printerJudgment.doatap_prot)" label='Α.Π. Επιστολής')
      el-input.big(type='text', placeholder='Εισάγετε Αρ.Πρωτ. της αίτησης εμμονής ', v-model='printerJudgment.doatap_prot')
    el-form-item(:label="calcLabel()")
      el-upload.upload-demo(
        ref='uploaPrint',
        accept='.pdf',
        :file-list='attachments',
        :http-request='addAttachment',
        :on-remove='handleRemove',
        :limit=1,
        :on-preview='viewPdf',
        v-loading="this.uploading"
        :before-remove='handleBeforeRemove',
        action='',
        :auto-upload='true',
        :show-file-list='true'
      )
        el-button(slot='trigger', size='small', type='primary', v-if='attachments.length===0', v-show='(this.isReappraisal && this.issuance) || (!this.isReappraisal && !this.issuance)') Επιλογή αρχείου
        .el-upload__tip(slot='tip', v-if='attachments.length===0') Επιλέξτε ΕΝΑ αρχείο pdf μεγέθους μέχρι 12MB
  hr
  div(style='text-align: center')
    el-button(size='mini', type='primary', round='', @click='tempSave', :disabled='false') Προσωρινή Αποθήκευση
    el-button(size='mini', type='danger', round='', @click='finalSave', :disabled='false') Οριστική Υποβολή
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import internalComments from '../common/internalComments'
import Proposals from '../common/Proposals'
import sharedMethods from '../common/sharedMethods.js'

export default {
  components: {
    internalComments,
    Proposals
  },
  mixins: [sharedMethods],
  mounted: function () {
    this.getPresidentDecisionFromID()
    if (this.application.attachedDocuments.find(doc => doc.type === 22 || doc.type === 1007 || doc.type === 1009)) {
      this.getPrintAttachment()
    }
  },
  props: ['application', 'isReappraisal', 'isPostExam'],
  data () {
    return {
      saving: false,
      uploading: false,
      generalJudgment: '',
      appFinalSaved: false,
      modified: false,
      attachments: [],
      fileData: '',
      fileName: '',
      presidentDecisionText: '',
      loadingPresidentDecision: true,
      issuance: null
    }
  },
  methods: {
    gradeLabel () {
      if (this.isPostExam) {
        return 'Τελικός βαθμός (μετά από εξετάσεις)'
      }
      return 'Βαθμός πτυχίου'
    },
    gradeDescriptionLabel () {
      if (this.isPostExam) {
        return 'Χαρακτηρισμός (μετά από εξετάσεις)'
      }
      return 'Χαρακτηρισμός'
    },
    calcLabel () {
      if (this.issuance === 'issueAct' || !this.issuance) {
        return 'Πράξη Αναγνώρισης'
      } else if (this.issuance === 'issueLetter') {
        return 'Επιστ. εμμονής'
      } else if (this.issuance === 'issueOverdue') {
        return 'Επιστ. απόρριψης'
      }
    },
    toggleQueue (val) {
    },
    calcStyleDraft () {
      return this.getDaysPassed(this.timeDraftUpload) > 5
        ? `background-color: red; border-radius: 20px; overflow-wrap: break-word; padding: 5px;`
        : `border-radius: 20px; overflow-wrap: break-word; padding: 5px;`
    },
    calcStyleApproval () {
      return this.timeApprovedByUser
        ? `background-color: #addfad; border-radius: 20px; overflow-wrap: break-word; padding: 5px;`
        : `border-radius: 20px; overflow-wrap: break-word; padding: 5px;`
    },
    addAttachment (file, fileList) {
      this.attachments.push(file.file)
      let self = this
      return this.getData(file.file).then(data => {
        self.fileData = data
        self.fileName = file.file.name
        self.newAttachment()
      })
    },
    getPrintAttachment () {
      this.attachments = []
      this.fileName = ''
      this.fileData = ''

      axios.get(
        `${this.BASE_URL}/printdecisions/uid/applications/${this.workingApplication.id}/attachments`
      ).then(res => {
        let file = res.data.data.doc_info
        let data = res.data.data.file

        this.attachments = [{
          name: file.old_name
        }]

        this.fileName = file.old_name
        this.fileData = data
        this.printerJudgment.doatap_prot = file.doatap_prot
      }).catch(err => {
        // No attachment
        err = null // Silence the linter
      })
    },
    handleRemove (file, fileList) {
      this.attachments = this.attachments.filter(attachment => attachment.uid !== file.uid)
      this.fileData = ''
      this.fileName = ''
      this.printerJudgment.doatap_prot = ''

      this.deleteAttachment()
    },
    handleBeforeRemove (file, fileList) {
      return this.$confirm(`Να αφαιρεθεί το ${file.name}？`)
    },
    getData (file) {
      return new Promise((resolve, reject) => {
        const fReader = new FileReader()
        let base64Pdf
        fReader.onload = (fileLoadedEvent) => {
          base64Pdf = fileLoadedEvent.target.result
          resolve(base64Pdf.split(',')[1])
        }
        fReader.readAsDataURL(file)
      })
    },
    finalSave () {
      this.$confirm('Η αίτηση προωθείται για υπογραφή. Ειστε σίγουροι ότι θέλετε να προχωρήσετε;',
        'Προειδοποίηση', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Άκυρο',
          type: 'warning'
        }).then(() => {
        this.saving = true
        axios.put(
          `${this.BASE_URL}/printdecisions/uid/applications/${this.workingApplication.id}/final`,
          {
            judgment: {
              comment: this.printerJudgment.comment
            }
          }
        ).then((response) => {
          this.saving = false
          this.$store.dispatch('LOAD_ASSIGNED_APPLICATIONS', this.activeLane)
          this.frontEndSuccessMsg('Η αίτηση προωθήθηκε με επιτυχία')
        }).catch(err => {
          this.saving = false
          this.frontEndError('Σφάλμα κατά την οριστική αποθήκευση')
          this.catchError(err)
        })
      })
    },
    newAttachment () {
      let payload
      if (!this.isReappraisal) {
        payload = {
          file: this.fileData,
          name: this.fileName,
          type: 22
        }
      } else {
        if (this.issuance === 'issueAct') {
          payload = {
            file: this.fileData,
            name: this.fileName,
            type: 22
          }
        } else if (this.issuance === 'issueLetter') {
          payload = {
            file: this.fileData,
            name: this.fileName,
            type: 1009,
            doatap_prot: this.printerJudgment.doatap_prot
          }
        } else if (this.issuance === 'issueOverdue') {
          payload = {
            file: this.fileData,
            name: this.fileName,
            type: 1007,
            doatap_prot: this.printerJudgment.doatap_prot
          }
        }
      }
      // if (this.isReappraisal) {
      //   if (this.acceptOverdue === false) { // αν η αίτηση απορρίφθηκε ως εκπρόθεσμη
      //     console.log('overdue app rejected')
      //     payload = {
      //       file: this.fileData,
      //       name: this.fileName,
      //       type: 1007
      //     }
      //   } else if (this.presidentDecisionText === 'ΕΜΜΟΝΗ ΣΤΗΝ ΠΡΟΗΓΟΥΜΕΝΗ ΠΡΑΞΗ ΑΝΑΓΝΩΡΙΣΗΣ') {
      //     console.log('emmoni')
      //     payload = {
      //       file: this.fileData,
      //       name: this.fileName,
      //       type: 1009
      //     }
      //   } else {
      //     console.log('act reappraisal')
      //     payload = {
      //       file: this.fileData,
      //       name: this.fileName,
      //       type: 22
      //     }
      //   }
      // } else if (!this.isReappraisal) {
      //   payload = {
      //     file: this.fileData,
      //     name: this.fileName,
      //     type: 22
      //   }
      // }
      this.uploading = true
      axios.post(
        `${this.BASE_URL}/printdecisions/uid/applications/${this.workingApplication.id}/attachments`, payload
      ).then((response) => {
        this.uploading = false
        this.frontEndSuccessMsg('Το αρχείο επισυνάφθηκε με επιτυχία')
      }).catch(err => {
        this.frontEndError('Σφάλμα κατά την επισύναψη του αρχείου')
        this.catchError(err)
      })
    },
    deleteAttachment () {
      this.uploading = true
      axios.delete(
        `${this.BASE_URL}/printdecisions/uid/applications/${this.workingApplication.id}/attachments`
      ).then((response) => {
        this.uploading = false
        this.frontEndSuccessMsg('Διαγραφή αρχείου επιτυχής')
      }).catch(err => {
        this.saving = false
        this.frontEndError('Διαγραφή αρχείου μη επιτυχής')
        this.catchError(err)
      })
    },
    tempSave () {
      this.saving = true
      axios.put(
        `${this.BASE_URL}/printdecisions/uid/applications/${this.workingApplication.id}/temp`,
        {
          judgment: {
            comment: this.printerJudgment.comment,
            queue: this.printerJudgment.queue,
            color: this.printerJudgment.color
          }
        }
      ).then((response) => {
        this.saving = false
        this.$store.dispatch('LOAD_ASSIGNED_APPLICATIONS', this.activeLane)
        this.$store.dispatch('LOAD_WORKING_APPLICATION', this.workingApplication.id)
        this.frontEndSuccessMsg('Τα δεδομένα αποθηκεύτηκαν με επιτυχία')
      }).catch(err => {
        this.saving = false
        this.frontEndError('Σφάλμα κατά την προσωρινή αποθήκευση')
        this.catchError(err)
      })
    },
    catchError (err) {
      this.backendError(err)
      throw err
    },
    viewPdf (file) {
      const base64Data = encodeURI(this.fileData)
      this.openPdfWindow(file.name + ' (' + file.id + ')', base64Data)
    },
    getPresidentDecisionFromID () {
      // const allowedStatuses = ['presidentW_Consultant', 'presidentW_after2fortnights',
      //   'presidentW_Viewer', 'presidentW_AcademicDirector_Reappraisal']
      // const foundStep = this.workingApplication.applicationHistory
      //   .slice()
      //   .reverse()
      //   .find(step => allowedStatuses.includes(step.applicationStatus))

      // const id = foundStep && foundStep.judgment ? foundStep.judgment.decision : null
      let id = this.workingApplication.applicationHistory.slice(0).reverse()
        .find(step => step.applicationStatus === 'presidentW_Consultant' ||
          step.applicationStatus === 'presidentW_after2fortnights' ||
          step.applicationStatus === 'presidentW_Viewer' ||
          step.applicationStatus === 'presidentW_AcademicDirector_Reappraisal' ||
          step.applicationStatus === 'presidentW_ReappraisalBoard')
        ? this.workingApplication.applicationHistory.slice(0).reverse()
          .find(step => step.applicationStatus === 'presidentW_Consultant' ||
            step.applicationStatus === 'presidentW_after2fortnights' ||
            step.applicationStatus === 'presidentW_Viewer' ||
            step.applicationStatus === 'presidentW_AcademicDirector_Reappraisal' ||
            step.applicationStatus === 'presidentW_ReappraisalBoard').judgment.decision
        : null
      console.log('id', id)
      if (id) {
        axios.get(
          `${this.BASE_URL}/final_decisions/${id}`
        ).then((response) => {
          this.presidentDecisionText = response.data.data.decision_text
          this.loadingPresidentDecision = false
        }, (err) => {
          this.presidentDecisionText = 'ΣΦΑΛΜΑ!'
          this.loadingPresidentDecision = false
          this.frontEndError('Σφάλμα κατά τη διαδικασία ανάκτησης της απόφασης του Προέδρου')
          this.catchError(err)
        })
      } else {
        if (this.isReappraisal) {
          this.workingApplication.overdue && !this.overdueAccepted ? this.presidentDecisionText = 'ΑΠΟΡΡΙΨΗ ΩΣ ΕΚΠΡΟΘΕΣΜΗΣ' : this.presidentDecisionText = 'ΕΜΜΟΝΗ ΣΤΗΝ ΠΡΟΗΓΟΥΜΕΝΗ ΠΡΑΞΗ ΑΝΑΓΝΩΡΙΣΗΣ'
          this.loadingPresidentDecision = false
        }
      }
    },
    getDaysPassed (dateString) {
      const [day, month, year] = dateString.split('-')
      const differenceInTime = new Date() - new Date(year, month - 1, day)
      return Math.floor(differenceInTime / (1000 * 60 * 60 * 24))
    }
  },
  computed: {
    overdueAccepted () {
      if (!this.isReappraisal) {
        return false
      }
      const targetStatus = ['presidentW_Viewer', 'presidentW_ReappraisalBoard']
      const foundStep = this.workingApplication.applicationHistory.slice().reverse()
        .find(step => targetStatus.includes(step.applicationStatus))
      const result = foundStep && foundStep.judgment && foundStep.judgment.acceptOverdue
      return result
    },
    timeApprovedByUser () {
      let doc = this.application.attachedDocuments.find(doc => doc.type === 22)
      return doc && doc.actApproval ? doc.actApproval.dateApproved : ''
    },
    timeDraftUpload () {
      let doc = this.application.attachedDocuments.find(doc => doc.type === 22)
      return doc ? doc.date : ''
    },
    actApproval () {
      let doc = this.application.attachedDocuments.find(doc => doc.type === 22)
      return doc && doc.actApproval
        ? doc.actApproval
        : {approved: null, dateApproved: null, comment: null}
    },
    praxeisNo () {
      return this.workingApplication.praxeisNo
    },
    departmentName () {
      return this.workingApplication.applicationHistory.slice(0).reverse()
        .find(step => (step.applicationStatus === 'presidentW_Viewer' || step.applicationStatus === 'presidentW_ReappraisalBoard'))
        ? this.workingApplication.applicationHistory.slice(0).reverse()
          .find(step => (step.applicationStatus === 'presidentW_Viewer' || step.applicationStatus === 'presidentW_ReappraisalBoard')).judgment.departmentName
        : null
    },
    // acceptOverdue () {
    //   return this.workingApplication.applicationHistory.slice(0).reverse()
    //     .find(step => step.applicationStatus === 'presidentW_Prechecker').judgment.acceptOverdue
    // },
    printerJudgment () {
      return this.workingApplication.applicationHistory.slice(0).reverse()
        .find(step => step.applicationStatus === 'printDecisionW_').judgment
    },
    ...mapState([
      'workingApplication',
      'BASE_URL',
      'activeLane'
    ])
  }
  // watch: {
  //   workingApplication: {
  //     handler: function (newData, oldData) {
  //       // this.getPrintAttachment()
  //     },
  //     deep: true
  //   }
  // }
}
</script>

<style scoped lang="scss">
.big {
  &.el-select {
    width: 450px;
  }
}
.biggest {
  &.el-textarea, &.el-input {
    max-width: 700px;
    width: 100%;
  }
}
.el-checkbox__label {
  background-color: transparent;
}
.el-form-item__content {
  line-height: 20px;
}
.el-form-item__label {
    text-align: right;
    float: left;
    font-size: 14px;
    color: #606266;
    line-height: 20px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}

.el-form-item {
  color: rgb(30, 0, 128);
  font-weight: bold;
  padding-right: 20px;
  padding-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/roleSpecific/PrintDecisionJudgment.vue